import { useNavigate } from 'react-router-dom';
import supabase from '../supabaseClient';
import { LogoSVG } from './ui/FormControls';

// ── Header ───────────────────────────────────────────────────────
export const Header = ({ currentUser, rol, setLoginUser, setLoginPass, setCurrentUser }) => {
  const navigate = useNavigate();
  return (
  <div className="text-white px-4 py-3 shadow" style={{ background: "linear-gradient(90deg,#0f172a,#1e3a5f)" }}>
    <div className="flex items-center justify-between max-w-2xl mx-auto">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: "linear-gradient(145deg,#0ea5e9,#0369a1)" }}>
          <LogoSVG size={20} />
        </div>
        <div>
          <h1 className="font-black text-lg leading-tight">Ware<span style={{ color: "#38bdf8" }}>Hause</span><span style={{ color: "#4ade80" }}>Plan</span></h1>
          <p className="text-blue-300 text-xs">Control & Validación</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <span className={`text-xs px-2 py-1 rounded-full font-semibold ${rol === "operario" ? "bg-blue-600" : "bg-green-600"}`}>{currentUser?.label}</span>
{currentUser?.siglas && (
  <span style={{ background: currentUser?.color, color: "white", fontSize: 10, fontWeight: 800, padding: "2px 6px", borderRadius: 6 }}>
    {currentUser?.siglas}
  </span>
)}
        <button onClick={async () => { await supabase.auth.signOut({ scope: "local" }); navigate("/app"); setLoginUser(""); setLoginPass(""); setCurrentUser(null); }} className="text-xs text-blue-300 hover:text-white px-2">⏻</button>
      </div>
    </div>
  </div>
  );
};
